angular.module('smartorg.r6.mgmts.createPortfolio').directive("createPortfolio", ["terminologyService", function (terminologyService) {
        return {
            restrict: 'E',
            template: require('../../template/create-portfolio.html'),
            transclude: true,
            scope: {
                createPortfolio: '&',
                terminology: '=?'
            },
            link: function (scope) {
                // Initialize terminology with defaults if not provided
                if (!scope.terminology) {
                    scope.terminology = terminologyService.getDefaultTerminology();
                }
                scope.$on('manage:SaveNewPortfolio', function () {
                    $('#createPortfolioModal').modal('show');
                });
                scope.portfolioName = "";
                scope.saveNewPortfolio = function () {
                    scope.createPortfolio({
                        newPortfolioName: scope.portfolioName
                    });
                    scope.resetPortfolio();
                };
                scope.resetPortfolio = function () {
                    scope.portfolioName = "";
                };
            }
        };
    }]);
//# sourceMappingURL=create-portfolio-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/create-portfolio/app/js/plumbing/create-portfolio-directive.js